'use es6';

import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import CalleeNumberOptions from './CalleeNumberOptions';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function CalleeOptions({
  appIdentifier,
  editPermissionsResults = null,
  callableObjectList,
  onEditProperty,
  onSelectToNumber,
  disabled,
  OptionIcon,
  onAddPropertyClick,
  showCalleeNames,
  disabledTooltipMessage,
  showAddPropertyButton
}) {
  const callableObjectArray = useMemo(() => callableObjectList.toArray(), [callableObjectList]);
  return /*#__PURE__*/_jsx(View, {
    "data-selenium-test": "callee-options",
    marginBlockStart: "200",
    as: "div",
    children: callableObjectArray.map(callableObject => {
      return /*#__PURE__*/_jsx(CalleeNumberOptions, {
        appIdentifier: appIdentifier,
        editPermissionsResults: editPermissionsResults,
        callableObject: callableObject,
        onEditProperty: onEditProperty,
        onSelectToNumber: onSelectToNumber,
        disabled: disabled,
        OptionIcon: OptionIcon,
        onAddPropertyClick: onAddPropertyClick,
        showCalleeNames: showCalleeNames,
        showAddPropertyButton: showAddPropertyButton,
        disabledTooltipMessage: disabledTooltipMessage
      }, callableObject.hashCode());
    })
  });
}
CalleeOptions.propTypes = {
  appIdentifier: PropTypes.string.isRequired,
  onEditProperty: PropTypes.func,
  onSelectToNumber: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  editPermissionsResults: ImmutablePropTypes.map,
  callableObjectList: ImmutablePropTypes.orderedMap,
  OptionIcon: PropTypes.object,
  onAddPropertyClick: PropTypes.func,
  showCalleeNames: PropTypes.bool.isRequired,
  disabledTooltipMessage: PropTypes.string,
  showAddPropertyButton: PropTypes.bool.isRequired
};
export default /*#__PURE__*/memo(CalleeOptions);